import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SerializedReel } from '../promote/types';
import { inlineMediaUrl } from '../promote/inlineMediaUrl';
import { ReelStatusPill } from '../promote/studio/aiReel/ReelStatusPill';
import { artistHomeMessages as messages } from './artistHomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PromoteLatestReelsProps {
  reels: SerializedReel[];
  onOpenStudio: () => void;
  onOpenReel: (uuid: string) => void;
}

/** The three newest reels with their status, and the way into the Reel Studio (design a1). */
const PromoteLatestReelsComponent: React.FC<PromoteLatestReelsProps> = ({ reels, onOpenStudio, onOpenReel }) => {
  const intl = useIntl();
  if (reels.length === 0) {
    return null;
  }

  return (
    <div className={styles.promoColumn}>
      <div className={`${styles.sectionKey} ${styles.columnHead}`}>
        <span>{intl.formatMessage(messages.promoteLatestReels)}</span>
        <button type="button" className={styles.linkButton} onClick={onOpenStudio}>
          {intl.formatMessage(messages.promoteReelStudio)}
        </button>
      </div>
      <div className={styles.reels}>
        {reels.map((reel) => {
          const posterUrl = reel.video?.posterUrl ?? null;
          return (
            <button key={reel.uuid} type="button" className={styles.reel} onClick={() => onOpenReel(reel.uuid)}>
              {posterUrl !== null && <img src={inlineMediaUrl(posterUrl)} alt="" />}
              <ReelStatusPill status={reel.status} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const PromoteLatestReels = TypedMemo(PromoteLatestReelsComponent);
